import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { ersattAvAnbudV2 } from '../../../data/modules';

function resolveIcon(name) {
  if (!name) return LucideIcons.Square;
  return LucideIcons[name] || LucideIcons.Square;
}

function relativeTime(ts) {
  if (!ts) return '';
  const now = Date.now();
  const delta = Math.max(0, now - ts);
  const min = Math.floor(delta / 60000);
  if (min < 1) return 'nyss';
  if (min < 60) return `${min} min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} h`;
  const days = Math.floor(hr / 24);
  if (days === 1) return 'igår';
  if (days < 7) return `${days} d`;
  return new Date(ts).toLocaleDateString('sv-SE');
}

function RecentRow({ item, onSelect }) {
  const Icon = useMemo(() => resolveIcon(item.iconName), [item.iconName]);
  return (
    <Link to={item.route} className="kp-recent-item" onClick={onSelect}>
      <span className="kp-recent-item-icon">
        <Icon size={14} strokeWidth={2} aria-hidden="true" />
      </span>
      <span className="kp-recent-item-label">{item.label}</span>
      <span className="kp-recent-item-time">{relativeTime(item.ts)}</span>
    </Link>
  );
}

export function RecentItems({ recent, onClear, onSelect, effectiveModuleKeySet = null }) {
  const modules = recent.getRecent('module', 5)
    .filter((it) => !ersattAvAnbudV2({ to: it.route }, effectiveModuleKeySet));
  if (modules.length === 0) {
    return (
      <div className="kp-recent-empty">
        Inga nyligen besökta moduler ännu.
      </div>
    );
  }
  return (
    <div className="kp-recent">
      <div className="kp-recent-header">
        <span>Nyligen</span>
        <button type="button" className="kp-recent-clear" onClick={onClear}>
          Rensa
        </button>
      </div>
      {modules.map((it) => (
        <RecentRow key={it.route} item={it} onSelect={onSelect} />
      ))}
    </div>
  );
}
